// @ts-nocheck


import { DatePicker as AntDatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

import { styledDatePicker } from './datePickerStyles';

const MomentDatePicker = AntDatePicker.generatePicker(momentGenerateConfig);

const StyledDatePicker = styledDatePicker(MomentDatePicker);
const StyledRangePicker = styledDatePicker(MomentDatePicker.RangePicker);
const StyledMonthPicker = styledDatePicker(MomentDatePicker.MonthPicker);

export {
  StyledRangePicker as RangePicker,
  StyledDatePicker as DatePicker,
  StyledMonthPicker as MonthPicker };